import type { UseFormReturn } from 'react-hook-form';
import type { CreateStartupFormValues } from '../../schema';
import { BasicDetails } from './sections/BasicDetails';
import { SectorStage } from './sections/SectorStage';
import { Financials } from './sections/Financials';
import { UploadsLinks } from './sections/UploadsLinks';

interface StepProps {
  form: UseFormReturn<CreateStartupFormValues>;
  trackUpload?: (id: string) => (isUploading: boolean) => void;
}

/** Step 1 "Company Info": sectioned cards per Figma 287:3098. */
export function Step1CompanyInfo({ form, trackUpload }: StepProps) {
  return (
    <div className="flex flex-col gap-6">
      <BasicDetails form={form} />
      <SectorStage form={form} />
      <Financials form={form} />
      <UploadsLinks form={form} trackUpload={trackUpload} />
    </div>
  );
}
